import BaseAiController from '@src/slide/application/service/ai-controller/core/base/base-ai-controller';
import { IAiControllerServiceDelegates } from '@src/slide/application/service/ai-controller/core/base/ai-controller.interface';

const ON_FINISH_MESSAGE = {
    type: 'ai-ppt-finish',
};

export default class PcAiController extends BaseAiController {
    public setServiceDelegates(services: IAiControllerServiceDelegates) {
        super.setServiceDelegates(services);
        this.services.aiAssistantService?.onSlideGenerateFinish(() => {
            window?.parent?.postMessage?.(ON_FINISH_MESSAGE, '*');
        });
    }
}
